import React from "react";

import { updateProductVisibility } from "@dashboard/products/api";
import { SelectField } from "@shared/form/SelectField/SelectField";
import { MultipleSelectFieldProps } from "@shared/form/SelectField/SelectField.types";
import { MinimalTableCell } from "@shared/table/MinimalTableComponents";
import { showErrorToast, showSuccessToast } from "@shared/toasts/Toasts";

const visibilityOptions = [
    { value: "ExportableBuilds", label: "Exportable builds" },
    { value: "PublicInheritance", label: "Public inheritance" },
    { value: "PublicFirmware", label: "Public firmware" },
    { value: "PublicDeviceRegistration", label: "Public device registration" },
];

export type VisibilityCellProps = { product: API.Product };

export const VisibilityCell = (props: VisibilityCellProps) => {
    const [selectedValues, setSelectedValues] = React.useState<string[]>(props.product.visibility ?? []);

    const handleVisibilityChange: MultipleSelectFieldProps["onChange"] = async (_event, selectedOption) => {
        try {
            const selectedValuesToSet = selectedOption.map((option) => option.value.toString());
            await updateProductVisibility(props.product.id, selectedValuesToSet);
            setSelectedValues(selectedValuesToSet);
            showSuccessToast("Visibility updated successfully");
        } catch (error) {
            const err = error as Error;
            showErrorToast(err.message || "Error while updating visibility");
        }
    };

    return (
        <MinimalTableCell>
            <SelectField
                options={visibilityOptions}
                value={visibilityOptions.filter((option) => selectedValues.includes(option.value))}
                onChange={handleVisibilityChange}
                fullWidth
                multiple
            />
        </MinimalTableCell>
    );
};
